import { Types } from '@store/types';

const initialState = {
	response: { data: [] }
};

const SupplierReducer = (state = initialState, action) => {
	switch (action.type) {
		case Types.FETCH_SUPPLIER_TYPE_WISE_LIST: {
			const { merge, data } = action.payload;
			const newData = merge ? [...state.response.data, ...data.data] : [...data.data];
			return {
				...state,
				response: {
					...data,
					data: newData
				}
			};
		}
		default:
			return state;
	}
};

export default SupplierReducer;
